// extracted by mini-css-extract-plugin
module.exports = {"add_new_detail":"form-edit-readiness_add_new_detail__3WCW_","mainTitle":"form-edit-readiness_mainTitle__37-eX","subText":"form-edit-readiness_subText__30PNH"};